"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNInputDialog = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _icons = require("@material-ui/icons");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    title: theme.typography.h3,
    subTitle: theme.typography.h5,
    header: {
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      alignItems: 'center',
      flexDirection: 'column'
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing.unit,
      top: theme.spacing.unit,
      color: theme.custom.colors.white,
      backgroundColor: theme.custom.colors.greyMedium,
      borderRadius: '50%'
    },
    muiDialog: {
      flex: 0,
      overflowY: 'inherit',
      width: '100%',
      paddingBottom: 0,
      paddingTop: 0
    }
  };
});

/**
 * A VN Dialog that pops up and provides an input field
 * @param {string} title - The title to display
 * @param {string} subTitle - The subtitle to display
 * @param {string} label - The title to display above the input field
 * @param {bool} open - the state of the dialog if it is open or closed
 * @param {object} rules - 
 * - validation: (val) => {} - called when the dialog wants to validate the input field
 * - showHelperText: (val) => {} - what helper text to show beneath the input field
 * - onBlur: (val) => {} - Called when you blur the input field, returns a value to set the input field
 * @param {func} onClose - Called when the dialog wants to close
 * @param {string} type - The type of input field you want: default is 'text'
 * @param {boolean} fullWidth - sets the vndialog to the full width
 * @param {boolean} closeOnSave - call close function on save
 * @param {boolean} endAdornment - display the arrow button
 * @param {number} width override default width
 * @param {string} subtitleVariant override subtitle variant with another IE theme.typography.h5
 */
var VNInputDialog = function VNInputDialog(props) {
  var theme = (0, _styles.useTheme)();
  var classes = useStyles();

  // INTERNAL STATE

  // used to format money
  var formatValue = function formatValue(value) {
    return (parseInt(value, 10) / 100 || 0).toFixed(2);
  };

  // the current input of the dialog text
  var _useState = (0, _react.useState)(""),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputVal = _useState2[0],
    setInputVal = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    placeholder = _useState4[0],
    setPlaceholder = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    pattern = _useState6[0],
    setPattern = _useState6[1];
  var _useState7 = (0, _react.useState)(""),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    inputPreValue = _useState8[0],
    setInputPreValue = _useState8[1];
  var _useState9 = (0, _react.useState)(props.type ? props.type : "text"),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    inputType = _useState10[0],
    setInputType = _useState10[1];

  // HANDLES

  (0, _react.useEffect)(function () {
    if (props.money) {
      setInputVal(formatValue(props.defaultValue));
      setPlaceholder("$0.00");
      setPattern('\d*');
      setInputPreValue("$");
      setInputType('tel');
    }
  }, []);

  // on open, make sure to reset it
  (0, _react.useEffect)(function () {
    if (props.open) {
      var newValue = "";
      if (props.money) {
        newValue = formatValue(props.defaultValue);
      }
      setInputVal(newValue);
    }
  }, [props.open]);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      handleSave();
      handleClose();
    }
  };

  // called on each character typed into the input field
  var onChange = function onChange(event) {
    if (props.money) {
      var input = event.target.value?.replace(/\D/g, '');
      var formattedValue = formatValue(input);

      // Save the current cursor position before updating the value
      setInputVal(formattedValue);

      // Move the cursor to the correct position after the input value is updated
      var cursorPosition = event.target.selectionStart;
      var valueLength = formattedValue.length + 1;
      if (cursorPosition <= 4) {
        setTimeout(function () {
          event.target.setSelectionRange(valueLength, valueLength);
        }, 0);
      }
    } else {
      setInputVal(event.target.value);
      event.target.scrollLeft = event.target.scrollWidth;
    }
  };

  // called when cancel button is clicked
  var handleClose = function handleClose() {
    if (props.onClose) {
      props.onClose();
    }
  };

  // called on input blur
  var handleBlur = function handleBlur(event) {
    if (props.rules && props.rules.onBlur) {
      var newVal = props.rules.onBlur(event.target.value);
      setInputVal(newVal);
    }
  };

  // LOCAL FUNCTIONS

  // Get the limits for the text field
  var showHelperText = function showHelperText() {
    if (props.rules && props.rules.showHelperText) {
      return props.rules.showHelperText(inputVal);
    }
    return '';
  };

  // returns an error if the validation doesn't pass
  var getInputError = function getInputError() {
    if (props.rules && props.rules.validation) {
      return !props.rules.validation(inputVal);
    }
    return false;
  };
  var renderTitle = function renderTitle() {
    if (props.title) {
      return /*#__PURE__*/_react.default.createElement(_Typography.default, {
        className: classes.title,
        align: "center",
        id: "form-dialog-title"
      }, props.title.split("\n").map(function (i, key) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: key
        }, i);
      }));
    }
  };

  // called when the save button is clicked
  var handleSave = function handleSave() {
    if (props.onSave) {
      var currentVal = inputVal;
      if (props.money) {
        currentVal = Math.round(inputVal * 100);
      }
      props.onSave(currentVal);
    }

    // if we set the auto close on save, call it
    if (props.closeOnSave && props.onClose) {
      props.onClose();
    }
  };
  var getStyle = function getStyle() {
    return (0, _objectSpread2.default)({}, theme.typography[props.subtitleVariant], {
      flex: 0,
      textAlign: 'center',
      fontWeight: 500
    });
  };
  var getDialogStyle = function getDialogStyle() {
    return {
      backgroundColor: theme.custom.colors.backgroundColor,
      width: props.width ? props.width : theme.custom.defaultDialog.width,
      height: '100%',
      margin: '0',
      marginTop: 8,
      marginBottom: 8,
      maxHeight: "calc(100% - ".concat(theme.spacing.unit * 2, "px)"),
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'column'
    };
  };
  var displaySubTitle = function displaySubTitle() {
    if (props.subTitle) {
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        pb: 2
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        className: classes.subTitle,
        style: getStyle()
      }, props.subTitle.split("\n").map(function (i, key) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: key
        }, i);
      })));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    fullWidth: props.fullWidth,
    open: props.open,
    PaperProps: {
      style: getDialogStyle()
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
    onClick: handleClose,
    className: classes.closeButton,
    color: theme.custom.colors.greyMedium,
    fontSize: "32"
  }), /*#__PURE__*/_react.default.createElement(_Box.default, {
    pb: 2,
    pt: 2,
    width: '100%'
  }, renderTitle()), /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    className: classes.muiDialog
  }, displaySubTitle(), /*#__PURE__*/_react.default.createElement(_Box.default, {
    pr: 6,
    pl: 6,
    pb: 2,
    display: 'flex'
  }, /*#__PURE__*/_react.default.createElement("input", {
    error: getInputError(),
    autoFocus: true,
    multiline: props.multiline ? props.multiline : false,
    margin: "dense",
    id: "vninputdialog",
    label: props.label,
    type: inputType,
    fullWidth: true,
    value: "".concat(inputPreValue).concat(inputVal),
    onChange: onChange,
    helperText: showHelperText(),
    onBlur: handleBlur,
    pattern: pattern,
    placeholder: placeholder,
    style: {
      background: theme.custom.colors.greyMedium,
      width: '100%',
      margin: 0,
      paddingLeft: 8,
      color: theme.custom.colors.mainTextColor,
      height: 50,
      border: "1px solid ".concat(theme.palette.primary.main)
    },
    onKeyDown: handleKeyDown
  }), props.endAdornment && /*#__PURE__*/_react.default.createElement(_Box.default, {
    pl: 1,
    pr: 1,
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    bgcolor: theme.palette.primary.main,
    onClick: handleSave
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowForward, {
    fontSize: "large",
    style: {
      color: theme.custom.colors.white
    }
  }))))));
};
exports.VNInputDialog = VNInputDialog;